<template>
    <div class="investors-m">
        <p class="indent"><span class="strong">ALCOMET AD</span> is a public joint-stock company with a two-tier management system, including Supervisory Board and Management Board. The members of the management bodies are elected for a 5-year mandate.</p>
        <p class="indent">On 12th of June, 2017, by the General Meeting of the Shareholders a new five years mandate of the Supervisory Board was elected with the following members:</p>
        <ol class="investors-m-ol">
            <li class="investors-m-li">Fikret Ince </li>
            <li class="investors-m-li">Fikret Kuzucu</li>
            <li class="investors-m-li">Semih Korai</li>
            <li class="investors-m-li">Bekir Yudzhel</li>
            <li class="investors-m-li">Hristo Todorov Dechev</li>
            <li class="investors-m-li">Osman Kerem Kuzucu</li>
            <li class="investors-m-li">Branimir Mladenov Mladenov</li>
        </ol>
        <p class="indent">After electing the Supervisory Board, the same with protocol N 77 at its meeting held elected for another five-year mandate a Management Board with members:</p>
        <ol class="investors-m-ol">
            <li class="investors-m-li">Huseyin Yorucu</li>
            <li class="investors-m-li">Huseyin Umut Ince</li>
            <li class="investors-m-li">Semih Baturay</li>
            <li class="investors-m-li">Neli Kancheva Toncheva</li>
            <li class="investors-m-li">Bulent Karakoc</li>
            <li class="investors-m-li">Mehmet Emrah Sazak</li>
        </ol>
        <p class="indent">The Company’s Corporate Governance Policy guarantees:</p>
        <ol class="investors-m-ol">
            <li class="investors-m-li">Protection of key shareholders’ rights;</li>
            <li class="investors-m-li">Equal treatment of all shareholders, including minority and non-resident shareholders;</li>
            <li class="investors-m-li">Protection of stakeholders’ rights and encouragement of effective cooperation between the Company and its stakeholders to provide welfare, open job positions and ensure sustainable development;</li>
            <li class="investors-m-li">Timely and accurate disclosure of information on all issues related to the Company, including its financial position, performance, ownership and production operations;</li>
            <li class="investors-m-li">Strategic corporate governance, efficient control on the activities of the Management Board and its accountability to the Supervisory Board, the Company and the shareholders.</li>
        </ol>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.investors-m p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.investors-m-ol {
  margin: 15px auto;
  list-style: decimal;
  padding-left: 20px;
  width: 60%;
}
.investors-m-li {
  display: list-item;
  font-size: 19px;
  line-height: 32px;
}
@media screen and (max-width: 1000px) {
  .investors-m > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .investors-m-ol {
    width: 100%;
    padding: 0 30px 0 50px;
  }
  .investors-m-li {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investors/Management.vue